import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { observable, computed } from 'mobx-angular';
import { ITaskInfo } from '../../interfaces/task-info';
import { HttpClient } from '@angular/common/http';
import {
  DialogStep,
  DialogStepPosition,
} from '../task-supplier-schedule/supplier-schedule-dialog.component';
import { TaskSupplierScheduleSource } from '../task-supplier-schedule/task-supplier-schedule-store';
import {
  UpdateTaskScheduleDTO,
  JobTaskSupplierScheduleContextTask,
  ConfirmAllocationRequest,
} from '../task-supplier-schedule/task-supplier-schedule';

@Component({
  selector: 'edit-task-schedule-dialog',
  templateUrl: './edit-task-schedule-dialog.component.html',
  styleUrls: ['./edit-task-schedule-dialog.component.scss'],
})
export class EditTaskScheduleDialogComponent implements OnInit {
  @Input() taskId: number;

  @Input() jobId: number;

  @Input() visible: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() taskScheduleSource: TaskSupplierScheduleSource =
    TaskSupplierScheduleSource.JobDeployment;

  @Input() referrPage: string;

  @Output() scheduleUpdated: EventEmitter<any> = new EventEmitter<any>();

  constructor(private http: HttpClient, private messageService: MessageService) {}

  ngOnInit() {}

  close() {
    this.visibleChange.emit(false);
  }

  saveTaskSupplierSchedule(request: ConfirmAllocationRequest) {
    let response = this.http.post('/api/Task/SupplierSchedule', request.updateTaskScheduleDTOs[0]);
    response.subscribe((r) => {
      this.scheduleUpdated.emit();
      this.visibleChange.emit(false);
      this.messageService.add(Message.Success('Task Schedule Updated'));
    });
  }
}
